import { ReactComponent as DownArrow } from "../../../../assets/icons/downArrow.svg";
import TableName from "../../../../components/common/tableName";
import React, { useState } from "react";
import { ReactComponent as RadioIcon } from "../../../../assets/icons/radioIcon.svg";
import Toggle from "../../../../components/common/toggle";
import Input from "../../../../components/common/input";
import { usePostCustomer } from "../../../../../common/hooks/console/management/customer/usePostCustomer";
import Spinner from "../../../../../common/components/spinner";
import { useAuthStore } from "../../../../store/useAuthStore";
import Button from "../../../../../common/components/button";
import useToastStore from "../../../../store/useToastStore";
// import SearchAddress from "../../../../components/common/searchAddress";
import NewOrderSearchAddress from "console/components/common/newOrderSearchAddress";

const NewCustomer = ({ onCustomerCreated }: { onCustomerCreated: (customerIdx: number, type: string) => void }) => {
    const initialState = {
        memberType: "customer",
        status: false,
        customerName: "",
        zoneCode: "",
        address: "",
        detailAddress: "",
        customerNameError: false,
    };

    const level = useAuthStore(state => state.m_level);

    const [state, setState] = useState(initialState);
    const [collapsed, setCollapsed] = useState(false);
    const [managerName, setManagerName] = useState<string>("");
    const [managerMobile, setManagerMobile] = useState<string>("");
    const [managerEmail, setManagerEmail] = useState<string>("");
    const [managerError, setManagerError] = useState(false);
    const [managerEmailError, setManagerEmailError] = useState(false);
    const [managerMobileError, setManagerMobileError] = useState(false);

    const { addToast } = useToastStore();

    const toggleCollapse = () => {
        setCollapsed(prev => !prev);
    };

    const { mutate, isPending } = usePostCustomer(customerIdx => {
        addToast({
            type: "success",
            message: "고객정보가 신규등록되었습니다.",
        });
        onCustomerCreated(customerIdx, state.memberType);
    });

    const handleAddressChange = (newZoneCode: string, newAddress: string, newDetailAddress: string) => {
        setState(prev => ({
            ...prev,
            zoneCode: newZoneCode,
            address: newAddress,
            detailAddress: newDetailAddress,
        }));
    };

    const handleSave = () => {
        let hasError = false;
        if (!state.customerName.trim()) {
            setState(prev => ({ ...prev, customerNameError: true }));
            hasError = true;
        }
        if (state.memberType === "other" && !managerName) {
            setManagerError(true);
            hasError = true;
        }
        if (state.memberType === "other" && !managerEmail) {
            setManagerEmailError(true);
            hasError = true;
        }
        if (state.memberType === "other" && !managerMobile) {
            setManagerMobileError(true);
            hasError = true;
        }
        if (hasError) return;

        mutate({
            customer_category: state.memberType === "customer" ? 1 : 2,
            status: state.status,
            customer_name: state.customerName,
            customer_post: state.zoneCode ?? "",
            customer_address: state.address ?? "",
            customer_address_detail: state.detailAddress ?? "",
            manager_name: managerName ?? "",
            manager_mobile: managerMobile ?? "",
            manager_email: managerEmail ?? "",
        });
    };

    const handleCancel = () => {
        setState(initialState);
    };

    const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, "");
        if (cleaned.length <= 3) return cleaned;
        if (cleaned.length <= 7) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
    };

    return (
        <div className="bg-gray6 p-4 h-full overflow-y-auto">
            {isPending && <Spinner />}
            <div className="bg-white shadow-custom rounded-xl px-3 py-5 flex flex-col gap-5">
                <p className="text-xl font-bold ">고객정보 신규등록</p>
                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <p className="text-gray2 font-bold">기본정보</p>
                        <DownArrow
                            onClick={toggleCollapse}
                            className={`cursor-pointer transform transition-transform ${collapsed ? "rotate-180" : ""}`}
                        />
                    </div>
                    {!collapsed && (
                        <>
                            <div className="border-t-2 border-gray2">
                                <div className="flex items-center border-b border-gray4">
                                    <TableName className="h-12" required>
                                        고객구분
                                    </TableName>
                                    <div className="flex items-center gap-4 w-full p-2">
                                        <label className="flex items-center w-1/2 gap-2 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="branch"
                                                value="customer"
                                                className="hidden peer"
                                                onChange={() => setState(prev => ({ ...prev, memberType: "customer" }))}
                                                checked={state.memberType === "customer"}
                                            />
                                            <div className="h-5 w-5 rounded-full border-2 border-gray4 flex items-center justify-center peer-checked:border-primary2 peer-checked:bg-primary2">
                                                {state.memberType === "customer" && <RadioIcon className="w-full h-full fill-white" />}
                                            </div>
                                            <span className="text-gray2">고객</span>
                                        </label>
                                        <label className="flex items-center gap-2 w-1/2 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="branch"
                                                value="other"
                                                className="hidden peer"
                                                onChange={() => setState(prev => ({ ...prev, memberType: "other" }))}
                                                checked={state.memberType === "other"}
                                            />
                                            <div className="w-5 h-5 rounded-full border-2 border-gray4 flex items-center justify-center peer-checked:border-primary2 peer-checked:bg-primary2">
                                                {state.memberType === "other" && <RadioIcon className="w-full h-full fill-white" />}
                                            </div>
                                            <span className="text-gray2">타지점</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="flex items-center border-b border-gray4">
                                    <TableName className="h-12" required>
                                        노출여부
                                    </TableName>
                                    <Toggle
                                        className="pl-2"
                                        onLabel="노출"
                                        offLabel="숨김"
                                        isOn={state.status}
                                        onToggle={(event, value) => {
                                            setState(prev => ({ ...prev, status: value }));
                                        }}
                                    />
                                </div>
                                <div className="flex items-center border-b border-gray4">
                                    <TableName className="h-12" required>
                                        거래처명
                                    </TableName>
                                    <Input
                                        className="px-2 w-full"
                                        placeholder="거래처명 입력"
                                        value={state.customerName}
                                        status={state.customerNameError ? "error" : undefined}
                                        onChange={e => {
                                            setState(prev => ({
                                                ...prev,
                                                customerName: e.target.value,
                                                customerNameError: false,
                                            }));
                                        }}
                                    />
                                </div>
                                <div className="border-b border-gray4 flex items-stretch">
                                    <TableName>주소</TableName>
                                    <NewOrderSearchAddress
                                        post={state.zoneCode}
                                        customerAddress={state.address}
                                        customerAddressDetail={state.detailAddress}
                                        onAddressChange={handleAddressChange}
                                    />
                                </div>
                                {state.memberType === "other" && (
                                    <div className="border-b border-gray4 flex items-stretch">
                                        <TableName required>담당자</TableName>
                                        <div className="flex flex-col gap-1 p-2 w-full">
                                            <Input
                                                placeholder="담당자 이름"
                                                value={managerName}
                                                onChange={e => {
                                                    setManagerName(e.target.value);
                                                    setManagerError(false);
                                                }}
                                                status={managerError ? "error" : level === 7 ? "view" : undefined}
                                            />
                                            <div className="flex gap-1">
                                                <Input
                                                    className=" w-full"
                                                    placeholder="담당자 연락처"
                                                    value={managerMobile}
                                                    onChange={e => {
                                                        setManagerMobile(formatPhoneNumber(e.target.value));
                                                        setManagerMobileError(false);
                                                    }}
                                                    status={managerMobileError ? "error" : level === 7 ? "view" : undefined}
                                                />
                                                <Input
                                                    className=" w-full"
                                                    placeholder="담당자 이메일"
                                                    value={managerEmail}
                                                    onChange={e => {
                                                        setManagerEmail(e.target.value);
                                                        setManagerEmailError(false);
                                                    }}
                                                    status={managerEmailError ? "error" : level === 7 ? "view" : undefined}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex w-full gap-2">
                                <Button size="L" className="w-full" onClick={handleCancel}>
                                    취소
                                </Button>
                                <Button size="L" status="regist" className="w-full" onClick={handleSave}>
                                    저장
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewCustomer;
